import React from 'react';
import { useNavigate } from 'react-router-dom';

const withNavigate = WrappedComponent => {
  function WithNavigate(props) {
    const navigate = useNavigate();
    return <WrappedComponent {...props} navigate={navigate} />;
  }
  WithNavigate.displayName = `withNavigate(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithNavigate;
};

export default withNavigate;
